import { HeadingV2 } from "src/components/HeadingV2/HeadingV2.tsx";
import { IconButtonV2 } from "src/components/IconButtonV2/IconButtonV2.tsx";
import type { ReactElement, MouseEventHandler } from "react";

export const TransferListTitle = (props: {
  title: string;
  rowsQty?: number;
}) => (
  <div css={{ marginBottom: 5, minHeight: "0", flexShrink: 0 }}>
    <HeadingV2 h={5} css={{ display: "inline" }}>
      {props.title}{" "}
    </HeadingV2>
    {props.rowsQty != null && (
      <HeadingV2 h={6} css={{ color: "#6F8390", display: "inline" }}>
        {`(${props.rowsQty})`}
      </HeadingV2>
    )}
  </div>
);

export const TransferListButton = (props: {
  icon: ReactElement;
  disabled: boolean;
  onClick: MouseEventHandler<HTMLButtonElement>;
}) => (
  <IconButtonV2
    skin="info"
    variant="outlined"
    size="sm"
    disabled={props.disabled}
    onClick={props.onClick}
  >
    {props.icon}
  </IconButtonV2>
);
